import styled from 'styled-components';

type BadgeContainerProps = {
    $size: 's' | 'm';
    $variant?: 'rounded' | 'border';
};

export const BadgeContainer = styled.div<BadgeContainerProps>`
    font-weight: 500;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    width: max-content;

    border-radius: ${(props) => {
        switch (props.$size) {
            case 's':
                return '4px';
            case 'm':
                return '8px';
        }

        return '8px';
    }};

    ${(props) => {
        switch (props.$size) {
            case 'm':
                return props.theme.typography.button;
            case 's':
                return props.theme.typography.smallTextBold;
        }

        return props.theme.typography.button;
    }}
    ${(props) => {
        if (props.$variant === 'border') {
            return `
                width: 14px;
                height: 14px;
    
                .badge-text {
                    display: none;
                }`;
        }

        return props.theme.typography.button;
    }}

    
    padding: ${(props) => {
        switch (props.$size) {
            case 's':
                return '4px 8px';
            case 'm':
                return '8px 16px';
        }

        return '8px 16px';
    }};
    color: ${(props) => props.theme.palette.primaryA7};
    &.success {
        background: ${(props) => props.theme.palette.secondaryA3};
    }

    &.error {
        background: ${(props) => props.theme.palette.secondaryA4};
    }

    &.warning {
        background: ${(props) => props.theme.palette.secondaryA6};
    }

    &.primary {
        background: ${(props) =>
            props.theme.components?.badge?.variant?.primary?.color ||
            props.theme.palette.primaryA1};
    }

    &.default {
        background: ${(props) => props.theme.palette.secondaryA8};
    }

    &.info {
        color: ${(props) => props.theme.palette.textLight};
        background: unset;
    }

    &.tooltip {
        cursor: pointer;
    }
    .badge-text {
        white-space: break-spaces;
    }

    .badge-left-addon {
        display: inline-flex;
        justify-content: center;
        align-items: center;

        svg {
            max-width: 16px;
            max-height: 16px;
        }
    }

    .badge-left-addon + .badge-text {
        margin-left: 8px;
    }
`;
